if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.storageKey = "maranello:recently-viewed-products";
      this.currentProductId = String(this.dataset.productId || "");
      this.productsToShow = Number(this.dataset.productsToShow) || 5;

      if (!this.currentProductId) return;

      let history;

      try {
        history = JSON.parse(localStorage.getItem(this.storageKey) || "[]");
      } catch (error) {
        return;
      }

      if (!Array.isArray(history)) history = [];

      const productIds = history
        .map(String)
        .filter((id, index, items) => id && id !== this.currentProductId && items.indexOf(id) === index)
        .slice(0, this.productsToShow);

      const updatedHistory = [
        this.currentProductId,
        ...history.map(String).filter((id) => id && id !== this.currentProductId),
      ].slice(0, 20);

      try {
        localStorage.setItem(this.storageKey, JSON.stringify(updatedHistory));
      } catch (error) {
        return;
      }

      if (productIds.length === 0) return;

      this.loadProducts(productIds);
    }

    async loadProducts(productIds) {
      const root = window.Shopify?.routes?.root || "/";
      const query = productIds.map((id) => `id:${id}`).join(" OR ");
      const url = new URL(`${root}search`, window.location.origin);
      url.searchParams.set("section_id", this.dataset.sectionId);
      url.searchParams.set("type", "product");
      url.searchParams.set("q", query);

      try {
        const response = await fetch(url.toString(), {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });

        if (!response.ok) return;

        const html = document.createElement("div");
        html.innerHTML = await response.text();
        const renderedSection = html.querySelector("recently-viewed-products");

        if (!renderedSection || !renderedSection.innerHTML.trim()) return;

        this.innerHTML = renderedSection.innerHTML;
      } catch (error) {
        return;
      }
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
